import authAxios from "../authAxios";

export const chargePaymentMethod = (
  tripId,
  activityId,
  roomId,
  selectedOptionalIds,
  backupTripIds,
  paymentMethodID,
  paymentOption,
  device,
  markupPercentage,
  promoCode,
  tripLeaderAgreed,
  offSession = true,
  packagePrice,
  guests,
  groupBookingName = null,
  // FE→BE price contract: the exact totals the customer agreed to on
  // screen. BE reconciler clamps actual charge to displayedTotalCash when
  // its own computed total is higher (prevents silent overcharges from
  // FE/BE divergence). Optional — BE no-ops gracefully when absent.
  priceContract = null,
  // Mount-time intent mint (the CNY PaymentElement fetchClientSecret): the BE
  // must never book on this call, even when pricing resolves to a $0 sentinel.
  intentMintOnly = false
) =>
  authAxios.post(`/v1/stripe/chargePaymentMethod`, {
    tripId,
    activityId,
    roomId,
    selectedOptionalIds,
    backupTripIds,
    paymentMethodID,
    paymentOption,
    device,
    markupPercentage,
    promoCode,
    tripLeaderAgreed,
    duckCode: sessionStorage.getItem("duck_code") ?? null,
    duckRedirectTrip: sessionStorage.getItem("duck_redirect_trip") ?? null,
    offSession,
    packagePrice,
    guests,
    groupBookingName,
    priceContract,
    intentMintOnly,
  });

export const customCheckout = (product_name, price, currency, success_url, cancel_url, metadata) =>
  authAxios.post(`/v1/stripe/createCustomCheckoutSession`, {
    product_name,
    price, // dollar not cents
    currency,
    success_url,
    cancel_url,
    metadata,
  });
